import { gql } from "@apollo/client";

export const UpdateNotificationSettings = gql`
    mutation UpdateNotificationSettings ($input: NotificationSettingsInput) {
        updateNotificationSettings(input: $input) {
            id
            general {
                push
                inApp
                email
            }
            schedule {
                isEnabled
                monday    { isEnabled from to }
                tuesday   { isEnabled from to }
                wednesday { isEnabled from to }
                thursday  { isEnabled from to }
                friday    { isEnabled from to }
                saturday  { isEnabled from to }
                sunday    { isEnabled from to }
            }
        }
    }
`;
